import React from 'react';

import useCountUp from '../../../hooks/useCountUp/useCountUp';

interface ICountUpNumberProps {
  value: number;
  duration?: number;
  decimals?: number;
  suffix?: string;
  className?: string;
}

const CountUpNumber = ({ value, duration = 1000, decimals = 0, suffix = '', className }: ICountUpNumberProps) => {
  const animated = useCountUp(value ?? 0, { duration, decimals });
  return <span className={className}>{`${animated}${suffix}`}</span>;
};

export default CountUpNumber;
